// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bedd7ada","239":"d04a4b3f","455":"21f6a9ca"}[chunkId] + ".chunk.js";
};